export default __webpack_public_path__ + "60606fbda331e8d14f46f95cc3ee661d.svg";